// Resolves the search term in /templates/:templateName to the one template a
// link meant to open, so a resource id from another page lands on the template
// itself rather than a filtered list.

// The version a bare template name refers to: the default one, since that is
// what production serves, falling back to the most recent when none is marked.
function pickPrimaryVersion(group) {
  if (!group?.length) return null;
  return group.find((template) => template.is_default === true) || group[0];
}

/**
 * The template to open for `term`, or null when it doesn't identify exactly
 * one. An exact name match wins outright, so a name that is a prefix of another
 * (..._fu alongside ..._fu_v2) still opens instead of being called ambiguous.
 *
 * @param {[string, object[]][]} groupedEntries name -> versions, already
 *   filtered by the same term
 */
export function resolveDeepLinkTemplate(groupedEntries, term) {
  const target = (term || "").trim().toLowerCase();
  if (!target) return null;

  const entries = groupedEntries || [];
  const exact = entries.find(([name]) => name.trim().toLowerCase() === target);
  const only = entries.length === 1 ? entries[0] : null;
  const match = exact || only;

  return match ? pickPrimaryVersion(match[1]) : null;
}
